export default class Mainvisual {

    constructor() {

        this.$mainvisual = document.getElementById('mainvisual');

        this.init();

    }

    init() {

        // 読込完了のイベントを追加
        this.addLoad();

        // スクロールイベントを追加
        this.addScroll();

        //youtubeモーダルを追加
        this.addModal();

        // お問い合わせボタンの表示／非表示の切り替え
        this.cvbtnBehavior();

    }

    addLoad() {

        window.addEventListener('load', () => this.$mainvisual.classList.add('-active'));
        window.addEventListener("load", () =>
            document.body.classList.add("-load")
        );

    }

    addModal() {

        const $openArray = [...document.querySelectorAll('.js-modal__open')],
            $modal = document.querySelector('.c-modal'),
            $inner = $modal.querySelector('.c-modal__inner'),
            $close = $modal.querySelector('button');

        $openArray.forEach($opener => {
            $opener.addEventListener('click', e => {
                e.stopPropagation();

                const src = $opener.dataset.src;
                const type = $opener.dataset.type;

                if(type === 'youtube'){
                    let tagstr = `
                        <div class="c-modal__video">
                            <div class="c-modal__video__inner"><iframe src="//www.youtube.com/embed/${src}?autoplay=1&mute=1&playsinline=1" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                        </div>`; 
                    $inner.innerHTML = tagstr;
                }
                else{
                    $inner.innerHTML = `<img src="${src}">`;

                    const $img = $inner.querySelector('img');
                    $img.addEventListener('load', () => {
                        $img.height > 890 ? $inner.classList.add('-vertical') : $inner.classList.remove('-vertical');
                    });
                }

                $modal.classList.add('-active');

            });
        });

        $close.addEventListener('click', () => {
            $modal.classList.remove('-active');
            $inner.innerHTML = '';
        });

    }

    addScroll() {

        const $topics = document.getElementById('topics');

        window.addEventListener('scroll', () => {
            const terms = 0 > $topics.getBoundingClientRect().top - window.innerHeight;
            terms ? this.$mainvisual.classList.add('-cover') : this.$mainvisual.classList.remove('-cover');
        });

    }

    cvbtnBehavior() {

        const $contact = document.querySelector('.l-contact'),
            $cvbtn = document.querySelector('.l-subpagenav__inquiry');
            
        if ($contact !== null && $cvbtn !== null) {
            
            //コンタクトボタンの交差
            window.addEventListener('scroll', () => {
                const tgt = $contact.getBoundingClientRect().top + window.pageYOffset,
                    scb = window.pageYOffset + window.innerHeight;
                if (scb >= tgt || window.pageYOffset <= 200) {
                    $cvbtn.classList.remove('-show');
                } else {
                    $cvbtn.classList.add('-show');
                }
            });  
        }

    }

}
